export const API_URL = process.env.REACT_APP_API_URL;
export const PAYMENT_API_URL = process.env.REACT_APP_PAYMENT_API_URL;
export const EP_URL = process.env.REACT_APP_EP_URL;